import { useParams } from 'react-router-dom-v5-compat'
import { useQuery } from '@tanstack/react-query'

import { FETCH_REGISTRY_KEY, fetchRegistry } from 'src/api/queries'
import { Registry } from 'src/types/registry'
import { track, withContextualizedTracking } from 'lib/analytics'
import RegistryGiftGiverPageSeo from './components/RegistryGiftGiverPageSeo'
import RegistryBackBannerPortal from './components/RegistryBackBannerPortal/RegistryBackBannerPortal'

const RegistryGiftGiverPage = () => {
  const { slug } = useParams()

  const registryQuery = useQuery({
    enabled: !!slug,
    queryKey: [FETCH_REGISTRY_KEY, slug],
    queryFn: () => fetchRegistry(slug),
  })
  const registry: Registry = registryQuery.data || {}

  return (
    <div>
      <RegistryBackBannerPortal registry={registry} />
      <RegistryGiftGiverPageSeo registry={registry} slug={slug} />
      <h1>{registry.title}</h1>
    </div>
  )
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.REGISTRY,
})(RegistryGiftGiverPage)
